// JsFromRoutes CacheKey 460840e46e8b89fddf724b6f549d0e4a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/buyers-concierge/events'),
}
